<div id="iframe">
    <iframe *ngIf="showIframe()" [src]="contentURL"></iframe>
    <video *ngIf="showVideo()" controls autoplay [src]="contentURL" type="video/mp4" #videoplayer>
        <!-- <source > -->
        Navigateur non supporté.
    </video>
</div>
